import { render, staticRenderFns } from "./DagelijkseSoepProduct.vue?vue&type=template&id=d31938ea&"
import script from "./DagelijkseSoepProduct.vue?vue&type=script&lang=js&"
export * from "./DagelijkseSoepProduct.vue?vue&type=script&lang=js&"
import style0 from "./DagelijkseSoepProduct.vue?vue&type=style&index=0&id=d31938ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports